import { Routes, Route } from "react-router-dom";
import MyPage from "../works/potion/pages/MyPage";
import Tickets from "../works/potion/pages/Tickets";
import ExchangeMoney from "../works/potion/pages/ExchangeMoney";
import Payment from "../works/potion/pages/Payment";
import Quests from "../works/potion/pages/Quests";
import HowToUse from "../works/potion/pages/HowToUse";
import News from "../default/pages/News";
import EmailSettings from "../works/potion/pages/EmailSettings";

import PayPayPolling from "../default/pages/PayPayPolling";
import PayPayCheck from "../default/pages/PayPayCheck";

export default function PotionRoutes() {
  return (
    <Routes>
      <Route path="/tickets" element={<Tickets />} />
      <Route path="/mypage" element={<MyPage />} />
      <Route path="/quests" element={<Quests />} />
      <Route path="/how-to-use" element={<HowToUse />} />
      <Route path="/news" element={<News />} />
      <Route path="/email-settings" element={<EmailSettings />} />
      <Route path="/exchange_money" element={<ExchangeMoney />} />
      <Route path="/payment" element={<Payment />} />

      <Route path="/paypay/polling" element={<PayPayPolling />} />
      <Route path="/paypay/check" element={<PayPayCheck />} />
    </Routes>
  );
}
